import React, {useCallback, memo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AnchorArrow, LinkStyle, RippleItem} from "./Styled";
import {validateField} from "../../../../utils/validation";
import {clickHandle, useMouseHoverHandle, useRippleEffect, useDelayNavigation} from "../utils";
import PropTypes from "prop-types";

const AnchorPWA = (props) => {
    const {
        linkHref,
        title,
        target,
        linkLabel,
        showLinkIcon,
        displayStyle,
        after,
        preventDefault,
        children,
        customClassName,
        forwardRef,
        onClickHandle,
        eventCategory,
        eventAction,
        enableRipple,
        isPWALink,
        rippleDuration,
        onPathChange,
        // eslint-disable-next-line no-unused-vars
        debug,
    } = props;
    const isMobile = useSelector((state) => state.layout.isMobile);
    const delayNavigation = useDelayNavigation();
    const {mouseHoverHandle, mouseHoverOut} = useMouseHoverHandle();
    const {ref, rippleState, createRipple} = useRippleEffect(enableRipple, rippleDuration);
    const attachRef = useCallback(
        (node) => {
            if (validateField(forwardRef, "object")) {
                forwardRef.current = node;
            } else if (typeof forwardRef === "function") {
                forwardRef(node);
            }
            ref.current = node;
        },
        [forwardRef, ref],
    );
    let preventDefaultVal = preventDefault || linkHref === "#";
    // const hashDefault = linkHref === '#';

    const dispatch = useDispatch();
    const paramsObj = {
        preventDefaultVal,
        linkHref,
        onClickHandle,
        eventCategory,
        eventAction,
        dispatch,
        enableRipple,
        createRipple,
        isPWALink,
        delayNavigation,
        onPathChange,
    };
    //May be needed : https://developers.google.com/web/updates/2017/01/scrolling-intervention
    //https://github.com/facebook/react/issues/9809
    // useEffect(() => {
    //     if(isMobile && hashDefault)
    //     {
    //
    //         const onTouchStart =(event)=>{
    //             clickHandle(event,paramsObj);
    //         };
    //         const onTouchEnd =(event)=>{event.preventDefault()};
    //         const onTouchMove =()=>{mouseHoverHandle(linkHref,dispatch)};
    //         ref.current.addEventListener("touchstart",onTouchStart,{passive:false});
    //         ref.current.addEventListener("touchmove",onTouchStart,{passive:false});
    //         ref.current.addEventListener("touchend",onTouchEnd,{passive:false});
    //         return () => {
    //             ref.current.removeEventListener('touchstart', onTouchStart);
    //             ref.current.removeEventListener('touchend', onTouchEnd);
    //             ref.current.removeEventListener('touchend', onTouchMove);
    //         };
    //     }
    // }, [isMobile,paramsObj,ref,hashDefault,linkHref,dispatch]);

    let jsx = (
        <React.Fragment>
            <LinkStyle
                to={linkHref}
                displaystyle={displayStyle}
                title={title}
                className={customClassName}
                forwardRef={attachRef}
                onClick={(event) => {
                    clickHandle(event, paramsObj);
                }}
                {...(isMobile
                    ? {
                          onTouchMove: () => {
                              mouseHoverHandle(linkHref, dispatch, preventDefaultVal);
                          },
                      }
                    : {
                          onMouseEnter: () => {
                              mouseHoverHandle(linkHref, dispatch, preventDefaultVal);
                          },
                      })}
                {...(isMobile
                    ? {}
                    : {
                          onMouseLeave: () => {
                              mouseHoverOut();
                          },
                      })}
                after={after}
                enableRipple={enableRipple}
            >
                {validateField(linkLabel) ? linkLabel : children}
                {validateField(rippleState, "object") && (
                    <RippleItem {...rippleState} rippleDuration={rippleDuration} />
                )}
            </LinkStyle>
            {showLinkIcon && <AnchorArrow onClick={() => window.open(linkHref, target).focus()} />}
        </React.Fragment>
    );

    return <React.Fragment>{jsx}</React.Fragment>;
};

AnchorPWA.propTypes = {
    linkHref: PropTypes.string,
    target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
    title: PropTypes.string,
    linkLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    showLinkIcon: PropTypes.bool,
    displayStyle: PropTypes.object,
    preventDefault: PropTypes.bool,
    children: PropTypes.node,
    active: PropTypes.bool,
    debug: PropTypes.bool,
    onClickHandle: PropTypes.func,
    eventCategory: PropTypes.string,
    eventAction: PropTypes.string,
    enableRipple: PropTypes.bool,
    linkType: PropTypes.bool,
    after: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    forwardRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.instanceOf(
                typeof Element === "undefined" ? function () {} : Element,
            ),
        }),
    ]),
    customClassName: PropTypes.string,
    isPWALink: PropTypes.bool,
    onPathChange: PropTypes.func,
    rippleDuration: PropTypes.number,
};

AnchorPWA.defaultProps = {
    enableRipple: true,
};

export default memo(AnchorPWA);
